import React, { useState } from 'react'

import { FormItem } from '@react/react-spectrum/Form'
import Heading from '@react/react-spectrum/Heading'
import NumberInput from '@react/react-spectrum/NumberInput'
import Select from '@react/react-spectrum/Select'
import Switch from '@react/react-spectrum/Switch'
import Textfield from '@react/react-spectrum/Textfield'

import ColorInput from 'components/ColorInput'
import MediaUpload from 'components/MediaUpload'
import JsonViewer from 'components/JsonViewer'

const FONTS = [
  { label: 'Proxima Nova', value: 'Proxima Nova' },
  { label: 'Adobe Clean', value: 'Adobe Clean' },
  { label: 'Lobster Two', value: 'Lobster Two' },
]

export default function ({ branding, project, disabled, onChange, onMetaChange }) {
  const [enableTargeting, setEnableTargeting] = useState(project.meta.enableBrandingTargeting)

  const onTargetingChange = (v) => {
    onMetaChange('enableBrandingTargeting')(v)
    setEnableTargeting(v)
  }
  return (
    <>
      <section>
        <Heading size='4'>Main Logo</Heading>

        <MediaUpload
          type='image'
          value={branding.logo}
          heading='Drag and Drop'
          onUpload={onChange('logo')}
          projectId={project?.meta?.id}
          path={'branding-logo'}
          withTextfield={true}
          disabled={disabled}
        />
      </section>
      <section>
        <Heading size='4'>Colors</Heading>

        <FormItem label='App Background'>
          <ColorInput
            placeholder='App Background'
            name='appBackgroundColor '
            value={branding.appBackgroundColor || branding.backgroundColor}
            onChange={onChange('appBackgroundColor')}
            disabled={disabled}
          />
        </FormItem>
        <FormItem label='Text'>
          <ColorInput
            placeholder='Text'
            name='textColor'
            value={branding.textColor || branding.loginScreenTextColor}
            onChange={onChange('textColor')}
            disabled={disabled}
          />
        </FormItem>
        <FormItem label='Top Bar Background'>
          <ColorInput
            placeholder='Top Bar Background'
            name='topBarBackgroundColor'
            value={branding.topBarBackgroundColor || branding.mainNavBackgroundColor}
            onChange={onChange('topBarBackgroundColor')}
            disabled={disabled}
          />
        </FormItem>

        <FormItem label='Top Bar Text'>
          <ColorInput
            placeholder='Top Bar Text'
            name='topBarTextColor'
            value={branding.topBarTextColor || branding.headerTextColor}
            onChange={onChange('topBarTextColor')}
            disabled={disabled}
          />
        </FormItem>
        <FormItem label='Text on Image'>
          <ColorInput
            placeholder='Text on Image'
            name='textOnImageColor'
            value={branding.textOnImageColor || '#ffffff'}
            onChange={onChange('textOnImageColor')}
            disabled={disabled}
          />
        </FormItem>
        <FormItem label='Bottom Bar Background'>
          <ColorInput
            placeholder='Bottom Bar Background'
            name='bottomBarBackgroundColor'
            value={branding.bottomBarBackgroundColor || branding.mainNavBackgroundColor}
            onChange={onChange('bottomBarBackgroundColor')}
            disabled={disabled}
          />
        </FormItem>
        <FormItem label='Bottom Bar Text'>
          <ColorInput
            placeholder='Bottom Bar Text'
            name='bottomBarTextColor'
            value={branding.bottomBarTextColor || branding.mainNavTextColor}
            onChange={onChange('bottomBarTextColor')}
            disabled={disabled}
          />
        </FormItem>
        <FormItem label='Bottom Bar Highligh'>
          <ColorInput
            placeholder='Bottom Bar Highligh'
            name='bottomBarHighlightColor'
            value={branding.bottomBarHighlightColor || branding.mainNavTextHighlightColor}
            onChange={onChange('bottomBarHighlightColor')}
            disabled={disabled}
          />
        </FormItem>

        <Heading size='4'>Fonts</Heading>

        <FormItem label='Heading Font'>
          <Select
            name='headingFontFamily'
            options={FONTS}
            value={branding.headingFontFamily || 'Proxima Nova'}
            onChange={onChange('headingFontFamily')}
            disabled={disabled}
          />
        </FormItem>
        <FormItem label='Body Font'>
          <Select
            name='bodyFontFamily'
            options={FONTS}
            value={branding.bodyFontFamily || 'Proxima Nova'}
            onChange={onChange('bodyFontFamily')}
            disabled={disabled}
          />
        </FormItem>
      </section>
      <section>
        <Heading size='4'>Button Styles</Heading>

        <FormItem label='Background'>
          <ColorInput
            placeholder='Background'
            name='buttonBackgroundColor'
            value={branding.buttonBackgroundColor || branding.primaryColor}
            onChange={onChange('buttonBackgroundColor')}
            disabled={disabled}
          />
        </FormItem>
        <FormItem label='Text'>
          <ColorInput
            placeholder='Text'
            name='buttonTextColor'
            value={branding.buttonTextColor || branding.primaryTextColor}
            onChange={onChange('buttonTextColor')}
            disabled={disabled}
          />
        </FormItem>
        <FormItem label='Border Radius'>
          <NumberInput
            placeholder='Border Radius'
            name='buttonBorderRadius'
            value={branding.buttonBorderRadius || 0}
            onChange={onChange('buttonBorderRadius')}
            disabled={disabled}
          />
        </FormItem>

        <Heading size='4'>Panel Styles</Heading>

        <FormItem label='Panel Background'>
          <ColorInput
            placeholder='Panel Background'
            name='panelBackgroundColor'
            value={branding.panelBackgroundColor || '#FFFFFF'}
            onChange={onChange('panelBackgroundColor')}
            disabled={disabled}
          />
        </FormItem>
        <FormItem label='Panel Border Color'>
          <ColorInput
            placeholder='Panel Border Color'
            name='panelBorderColor'
            value={branding.panelBorderColor || '#DEDEDE'}
            onChange={onChange('panelBorderColor')}
            disabled={disabled}
          />
        </FormItem>

        <FormItem label='Panel Border Radius'>
          <NumberInput
            placeholder='Panel Border Radius'
            name='panelBorderRadius'
            value={branding.panelBorderRadius || 0}
            onChange={onChange('panelBorderRadius')}
            disabled={disabled}
          />
        </FormItem>
      </section>

      <section>
        <Heading size='4'>Targeting</Heading>
        <Switch label='Enable Targeting' defaultChecked={!!enableTargeting} onChange={onTargetingChange} />

        <FormItem label='Mbox Name' labelFor='Mbox Name'>
          <Textfield
            placeholder='Mbox Name'
            name='brandingMboxName'
            value={project.meta.brandingMboxName}
            onChange={onMetaChange('brandingMboxName')}
            disabled={!enableTargeting || disabled}
          />
        </FormItem>
        <JsonViewer
          content={branding}
          buttonLabel='Sample Offer Content'
          dialogTitle='Sample Offer Content'
          indent={2}
        />
      </section>
    </>
  )
}
